<template>
  <div class="border rounded attachment">
    <div v-for="(file, key) in files" :key="file.id" class="attachment__item-container p-12px gap-12px">
      <i :class="determineIconClass(file)"></i>
      <div class="meta">
        <div class="file-name text-truncate">{{ file.name }}</div>
        <div class="file-size">{{ file.sizeInKB }} KB</div>
      </div>
      <slot name="tool-button" v-bind:file="{...file, key}">
        <a :href="file.url" target="_blank">
          <b-button variant="link">View</b-button>
        </a>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    files: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ICON_CLASS_PDF: "bx bxs-file-pdf pdf-icon",
      ICON_CLASS_IMAGE: "bx bxs-image image-icon",
    };
  },
  methods: {
    determineIconClass(file) {
      const isPdf = file.extension === "pdf";
      return isPdf ? this.ICON_CLASS_PDF : this.ICON_CLASS_IMAGE;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/design/colors";

.attachment {
  width: calc(50% - 12px) !important;

  &__item-container {
    &:not(:last-child) {
      border-bottom: 1px solid #eaecf0;
    }

    display: flex;
    align-items: center;

    .pdf-icon {
      font-size: 24px;
    }

    .image-icon {
      font-size: 24px;
    }

    .file-name {
      font: 400 10px/12px Inter;
      color: #171717;
    }

    .file-size {
      font: 400 10px/12px Inter;
      color: #737373;
    }

    .meta {
      width: 61%;
      flex-grow: 1;
    }
  }
}
</style>